import React, {useRef, useState} from 'react';

import K from '../k';
import _ from 'lodash';
import Icon from './icon';
import useClickOutside from '../hooks/click-outside';

const {placements} = K;

//HINT some code is kinda sloppy, but I was trying to
// write it so its easy to convert to a reusable component in the future
const NavMenu = ({placement = placements.RIGHT, links}) => {
  const ref = useRef();
  const [isCollapsed, setIsCollapsed] = useState(true);

  useClickOutside(ref, () => setIsCollapsed(true));

  const styles = {
    container: {
      position: 'relative',
      zIndex: 2,
    },
    contentContainer: {
      cursor: 'pointer',
      position: 'absolute',
      listStyleType: 'none',
      margin: 0,
      padding: 0,
      marginTop: 4,
      backgroundColor: K.colors.base,
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: '7px 0px 7px 7px',
      width: 'fit-content',
      minWidth: '200px',
      color: 'black',
      [placement]: 0,
    },
    listItem: {
      padding: 0,
      height: K.spacing * 3,
    },
    link: (index) => ({
      ...K.fonts.standard,
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      textOverflow: 'ellipsis',
      padding: '4px 5px 4px 5px',
      borderRadius: `${index === 0 ? '7px' : '0'} 0 ${index === links?.length - 1 ? '7px' : '0'} ${index === links?.length - 1 ? '7px' : '0'}`,
      width: '100%',
      height: '100%',
    })
  };

  const handleToggleIsCollapsed = () => setIsCollapsed(!isCollapsed);

  return (
    <div ref={ref} style={styles.container}>
      <Icon name='menu' theme='white' onClick={handleToggleIsCollapsed}/>
      {!isCollapsed &&
        <ul style={styles.contentContainer}>
          {_.map(links, ({key, label, href}, index) => (
            <li key={`li-${key}`} style={styles.listItem}>
              <a
                {...{href}}
                key={`a-${key}`}
                target={'_blank'}
                rel={'noreferrer'}
                className='hoverable'
                style={styles.link(index)}
              >{label}</a>
            </li>
          ))}
        </ul>
      }
    </div>
  );
};

export default NavMenu;
